import { DropdownOption } from 'components/final-form/dropdownUtils';
import React, { Component } from 'react';
import { MessageSourceProps, withMessages } from 'react-message-source';
import { Button, Header, Menu, Tab, Table } from 'semantic-ui-react';
import LoaderComponent from 'components/LoaderComponent';
import styled from 'styled-components';
import { numberFormatter } from 'utils/fomattingUtils';
import { Field, Form as FinalForm, FormRenderProps } from 'react-final-form';
import moment from 'moment';
import { CancelTokenSource } from 'axios';
import axios from 'services/http';
import { AuthConsumerRenderProps, withAuthContext } from 'auth/AuthContext';
import { FormApi } from 'final-form';
import VirtualizedTable from 'components/layout/VirtualizedTable';
import FormButtonsRow from 'components/layout/FormButtonsRow';
import FormContent from 'components/layout/FormContent';
import {
  PaymentJournalPrintRequest,
  PaymentJournalPrintResponse,
  PaymentJournalSearchResponse,
  TreaterSummaryData
} from 'ts-types/api.types';
import ErrorMessage from 'components/final-form/ErrorMessage';
import { BillReceiver, PaymentJournalPaymentType } from 'ts-types/api.enums';
import { withRouterWorkaround } from 'utils/workaroundUtils';
import { RouteComponentProps } from 'react-router';
import { PaymentJournalFormData } from 'components/billing/payment-journal/PaymentJournalView';
import { getPaymentJournalPdfUrl, getPaymentJournalPrintPreview } from 'services/paymentJournalServices';
import EmptyDataMessage from 'components/layout/EmptyDataMessage';
import PdfModal from 'components/pdf-modal/PdfModal';
import SearchResultComponent from 'components/SearchResultComponent';

const StyledTable = styled(VirtualizedTable)`
  .ReactVirtualized__Table__Grid {
    outline: none;
    border: 1px solid rgba(34, 36, 38, .15);
    border-top: none;
    border-radius: 0 0 .28571429rem .28571429rem;
  }

  .ReactVirtualized__Table__row {
    border-left: none;
  }

  .ReactVirtualized__Table__row.totalRow {
    font-weight: 700;
    background-color: rgba(0, 0, 0, .2);

    &:hover {
      background-color: rgba(0, 0, 0, .2) !important;
    }
  }

  .ReactVirtualized__Table__headerColumn {
    height: 100%;
    border-right: 1px solid rgba(34, 36, 38, .15);
    padding-top: 0.85rem;
  }

  .ReactVirtualized__Table__headerColumn:last-child {
    border-right: none;
  }

  .ReactVirtualized__Table__rowColumn {
    height: 100%;
    border-right: 1px solid rgba(34, 36, 38, .15);
    padding-top: 0.85rem;
  }

  .ReactVirtualized__Table__rowColumn.noBorder {
    border-right: none;
  }

  .ReactVirtualized__Table__rowColumn:last-child {
    border-right: none;
  }
`;

const StyledTotalsRowTable = styled(VirtualizedTable)`
  .ReactVirtualized__Table__Grid {
    display: none;
  }

  .ReactVirtualized__Table__row {
    border-left: none;
    border-radius: 0 0 .28571429rem .28571429rem;
  }

  .ReactVirtualized__Table__headerRow.headerRow {
    background-color: rgba(0, 0, 0, .2);
    border-top: none;
    border-radius: 0 0 .28571429rem .28571429rem;
  }

  .ReactVirtualized__Table__headerColumn {
    height: 100%;
    border-right: none;
    padding-top: 0.85rem;
    padding-right: 1rem;
  }

  .ReactVirtualized__Table__headerColumn:last-child {
    border-right: none;
  }

  .ReactVirtualized__Table__rowColumn {
    height: 100%;
    border-right: none;
    padding-top: 0.85rem;
  }

  .ReactVirtualized__Table__rowColumn.noBorder {
    border-right: none;
  }

  .ReactVirtualized__Table__rowColumn:last-child {
    border-right: none;
  }
`;


const BillsContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  position: relative;
  min-height: 220px;
  height: 100%;
`;

const TotalsContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const TotalsRowContainer = styled.div`
  position: relative;
  min-height: 46px;
`;

const StyledForm = styled.form`
  display: flex;
  flex-flow: column;
  height: 100%;

  .bill-list-form {
    display: flex;
    flex-direction: column;
  }
`;

const StyledFormContent = styled.div`
  flex: 1 1 auto;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-around;
  margin-bottom: 15px;
`;

const StyledContainer = styled.div`

  flex: 1 1 auto;
  display: flex;
  flex-direction: column;

  .ui.header:not(h1):not(h2):not(h3):not(h4):not(h5):not(h6) {
    font-size: 1.1rem;
    color: #373737;

    &.small {
      font-size: 1.05em;
    }
  }

  &.margin {
    margin-left: 20px;
  }
`;

const ScrollableTableWrapper = styled.div`
  flex: 1 1 auto;
  height: 100%;
  min-height: 250px;
  max-height: calc(100vh - 487px);
  overflow-y: auto;
  overflow-x: hidden;
  width: 100%;
  border: 1px solid rgba(34, 36, 38, .15);
  box-shadow: none;
  border-radius: .28571429rem;

  & .ui.table {
    border: none;
  }

  & .ui.table thead tr:first-child > th {
    position: sticky !important;
    top: 0;
    z-index: 2;
    background: #fff;
  }

  & .ui.table tbody tr:last-child > td {
    border-bottom: 1px solid rgba(34, 36, 38, .15)
  }
`;

const StyledCell = styled.div`
  text-align: right;
  padding-right: 0.4rem;
`;

const StyledPatientId = styled.span`
  color: #757575;
`;

const StyledFormButtonsRow = styled(FormButtonsRow)`
  margin-top: 1rem;
`;

const CashBoxContainer = styled.div`
  margin-top: 2rem;

  .header {
    float: right;
    margin-right: 2rem;
  }
`;

const StyledTab = styled(Tab)`
  height: 100%;
  display: flex;
  flex-direction: column;

  .ui.attached.tabular.menu {
    padding-left: 0.85rem;
    border: none !important;
  }

  .ui.attached.segment {
    border: none !important;
  }

  .ui.segment {
    border: none !important;
  }
`;

const styledPane = {
  borderBottom: "none",
  borderLeft: "none",
  borderRight: "none",
  paddingLeft: 0,
  paddingRight: 0,
  paddingTop: 0,
  paddingBottom: 0,
  height: "100%",
  marginBottom: 0
};

const totalsMargin = {
  marginBottom: "30px"
}

interface Props extends MessageSourceProps, AuthConsumerRenderProps, RouteComponentProps {
  bills: Array<PaymentJournalSearchResponse>,
  treaterSummaryData: Array<TreaterSummaryData>,
  totalAmount: number,
  totalPaidAmount: number,
  billsLoading: boolean,
  formData: PaymentJournalFormData,
  treaters: Array<DropdownOption>,
  setErrorMessage: (errorMessage?: string) => void
}

interface State {
  paymentJournalPdfData?: PaymentJournalPrintResponse,
  paymentJournalPdfModalOpen: boolean,
  cancelTokenSource: CancelTokenSource
}

class PaymentJournalTableSegment extends Component<Props, State> {

  constructor(props: Props) {
    super(props);

    const cancelTokenSource = axios.CancelToken.source();

    this.state = {
      paymentJournalPdfModalOpen: false,
      cancelTokenSource: cancelTokenSource
    };
  }

  getPdfUrl = (paymentJournalResponse: PaymentJournalPrintResponse) => {
    return getPaymentJournalPdfUrl(paymentJournalResponse.pdfId, paymentJournalResponse.pdfName);
  }

  openPaymentJournalPdfModal = (paymentJournalResponse: PaymentJournalPrintResponse) => {
    this.setState({
      paymentJournalPdfModalOpen: true,
      paymentJournalPdfData: paymentJournalResponse
    })
  };

  closePaymentJournalPdfModal = () => {

    this.setState({
      paymentJournalPdfModalOpen: false,
      paymentJournalPdfData: undefined
    });
  };

  billDateCellRenderer = ({rowData}: any) => {
    const {bills} = this.props;
    if (rowData.index > bills.length) {
      return "";
    }
    return (
        <div>{moment(rowData.date).format("DD.MM.YYYY")}</div>
    );
  }

  amountCellRenderer = ({rowData}: any) => {
    return <StyledCell>{numberFormatter.format(rowData.amount)}</StyledCell>
  }

  paidAmountCellRenderer = ({rowData}: any) => {
    return <StyledCell>{numberFormatter.format(rowData.paidAmount)}</StyledCell>
  };

  billsRowGetter = (bills: Array<PaymentJournalSearchResponse>) => ({index}: any) => {

    if (bills[index]) {
      Object.assign(bills[index], {index: index + 1});

      return bills[index];
    }

    return {
      index: index + 1
    }
  };

  billReceiverCellRenderer = ({rowData, cellData}: any) => {
    const {bills} = this.props;
    if (rowData.index > bills.length) {
      return "";
    }
    if (cellData === BillReceiver.PATIENT) {
      return (
          <div>{`${rowData.patientFullName}, ${rowData.patientCity}`}</div>
      );
    }
    return (
        <div>{`${rowData.guarantorDescription}`}</div>
    );
  };

  patientCellRenderer = ({rowData, cellData}: any) => {
    const {bills, getMessage} = this.props;
    if (rowData.index > bills.length) {
      return "";
    }
    if (cellData) {
      return (
          <div><StyledPatientId>{rowData.patientId}</StyledPatientId> - {rowData.patientFullName}</div>
      );
    }

    return getMessage("billJournal.various");
  };

  treaterUsernameCellRenderer = ({rowData, cellData}: any) => {
    const {bills, getMessage} = this.props;
    if (rowData.index > bills.length) {
      return "";
    }
    if (cellData) {
      return (<div>{rowData.treaterUsername}</div>);
    }

    return "";
  };

  billsRowRenderer = ({className, columns, index, key, style}: any) => {

    const {bills} = this.props;
    const numberOfBills = bills.length;

    const a11yProps = {"aria-rowindex": index + 1};

    let styles = {...style, userSelect: "none"};

    const totalIx = index + 1;

    if (totalIx > numberOfBills) {

      const noBorderFieldsIndexes = [0, 1, 2, 3];

      className = className + " totalRow";

      return (
          <div
              {...a11yProps}
              className={className}
              key={key}
              role="row"
              style={styles}
          >
            {
              columns.map((column: any, index: number) => {
                let editColumn = {...column, props: {...column.props}};
                if (noBorderFieldsIndexes.includes(index)) {
                  editColumn.props.className = `${editColumn.props.className}noBorder`;
                  return editColumn;
                }
                return editColumn;
              })
            }
          </div>
      );
    }

    return (
        <div
            {...a11yProps}
            className={className}
            key={key}
            role="row"
            style={styles}
        >
          {columns}
        </div>
    );
  };

  handleSubmit = async (values: Partial<PaymentJournalFormData>) => {

    const {bills} = values;
    const {cancelTokenSource} = this.state;
    const {setErrorMessage, getMessage} = this.props;

    if (bills && bills.length) {
      const billIds: Array<number> = bills.map(bill => bill.id);

      const paymentJournalPrintRequest: Partial<PaymentJournalPrintRequest> = {
        mandateId: values.mandateId,
        fromDate: values.fromDate,
        toDate: values.toDate,
        paymentType: values.paymentType,
        cashBox: values.cashBox,
        treaterId: values.treaterId,
        billIds: billIds
      }

      await getPaymentJournalPrintPreview(paymentJournalPrintRequest, cancelTokenSource)
          .then(response => {
            this.openPaymentJournalPdfModal(response);

          })
          .catch((error) => setErrorMessage(getMessage("error.general")));
    }
  };

  renderTreatersSummary = () => {
    const {treaterSummaryData, getMessage} = this.props;

    return (
        <ScrollableTableWrapper>
          <Table celled>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>{getMessage("paymentJournal.numberOfBills")}</Table.HeaderCell>
                <Table.HeaderCell>{getMessage("paymentJournal.username")}</Table.HeaderCell>
                <Table.HeaderCell>{getMessage("paymentJournal.totalAmount")}</Table.HeaderCell>
                <Table.HeaderCell>{getMessage("paymentJournal.totalPaidAmount")}</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {
                treaterSummaryData.map((summary: TreaterSummaryData, index: number) => {
                  return (
                      <Table.Row key={index}>
                        <Table.Cell width={2}>
                          {summary.numberOfBills}
                        </Table.Cell>
                        <Table.Cell width={4}>
                          {summary.username}
                        </Table.Cell>
                        <Table.Cell width={3}>
                          {numberFormatter.format(summary.totalAmount)}
                        </Table.Cell>
                        <Table.Cell width={3}>
                          {numberFormatter.format(summary.totalPaidAmount)}
                        </Table.Cell>
                      </Table.Row>
                  );
                })
              }
            </Table.Body>
          </Table>
        </ScrollableTableWrapper>
    )
  };

  render(): React.ReactNode {
    const {paymentJournalPdfModalOpen, paymentJournalPdfData} = this.state;
    const {formData} = this.props;

    return (
        <React.Fragment>
          <FinalForm
              onSubmit={this.handleSubmit}
              initialValues={formData}
              subscription={{values: true, pristine: true, submitting: true}}
              render={this.renderForm}
          />
          {
            paymentJournalPdfModalOpen &&
            <PdfModal
                modalOpen={paymentJournalPdfModalOpen}
                onCloseModal={this.closePaymentJournalPdfModal}
                pdfResponses={[paymentJournalPdfData]}
                getPdfUrl={this.getPdfUrl}
            />
          }
        </React.Fragment>
    )
  };

  renderPaidBillsContent = (form: FormApi, values: any, bills: any): React.ReactNode => {
    const {billsLoading} = this.props;

    const countBills = bills.length;
    const emptyBillArray = countBills < 1;

    return (
        <React.Fragment>
          <BillsContainer>
            {billsLoading
                ? this.renderTablesLoader("bills")
                : this.renderBillsTable(form, values, bills)}
          </BillsContainer>
          {
            !emptyBillArray &&
            <React.Fragment>
              <TotalsRowContainer>
                {this.renderTotalsRowTable()}
              </TotalsRowContainer>
            </React.Fragment>
          }
          {PaymentJournalPaymentType.CASH === values.paymentType &&
          this.renderCashBox(values)
          }
        </React.Fragment>
    );
  }

  renderSummaryContent = (uniqueTreaterIds: Array<any>): React.ReactNode => {
    return (
        uniqueTreaterIds.length > 1 ?
            <TotalsContainer>
              {this.renderTreatersSummary()}
            </TotalsContainer>
            : <EmptyDataMessage messageKey="paymentJournal.emptyTreaterTable"/>
    );
  }

  renderForm = ({handleSubmit, submitting, values, form}: FormRenderProps): React.ReactNode => {

    const {bills} = values;
    const {getMessage} = this.props;

    const countBills = bills.length;
    const emptyBillArray = countBills < 1;

    const treaterIds = bills.map((bill: PaymentJournalSearchResponse) => bill.treaterId);
    // @ts-ignore
    const uniqueTreaterIds = [...new Set(treaterIds)];

    const billsStyledPane = !emptyBillArray ? {...styledPane, marginBottom: "30px"} : styledPane;

    const panes = [
      {
        menuItem: (
            <Menu.Item key="messages">
              <SearchResultComponent numResults={countBills} textMessage={"header.navigation.billJournalResults"}/>
            </Menu.Item>
        ),
        pane: {
          key: "bills",
          content: this.renderPaidBillsContent(form, values, bills),
          style: billsStyledPane
        }
      },
      {
        menuItem: getMessage("paymentJournal.summary"),
        pane: {
          key: "paymentJournal.summary",
          content: this.renderSummaryContent(uniqueTreaterIds),
          style: styledPane
        }
      }
    ];

    return (
        <StyledForm onSubmit={handleSubmit}>
          <FormContent className="bill-list-form">
            <Field
                name="error"
                component={ErrorMessage}
            />
            <StyledFormContent>
              <StyledContainer style={{width: "100%"}}>
                <StyledTab menu={{secondary: true, pointing: true}} panes={panes} renderActiveOnly={false}/>
              </StyledContainer>
            </StyledFormContent>
          </FormContent>
          <StyledFormButtonsRow>
            <Button compact type="submit" primary disabled={submitting || emptyBillArray}>
              {getMessage("output")}
            </Button>
          </StyledFormButtonsRow>
        </StyledForm>
    );
  };

  renderBillsTable = (form: FormApi, values: any, bills: Array<PaymentJournalSearchResponse>): React.ReactNode => {

    const {getMessage} = this.props;

    const rowCount = bills.length;

    return (
        <StyledTable
            rowGetter={this.billsRowGetter(bills)}
            rowRenderer={this.billsRowRenderer}
            rowCount={bills.length > 0 ? rowCount : 0}
            columns={[
              {
                width: 100,
                label: getMessage("paymentJournal.billNumber"),
                dataKey: "id"
              },
              {
                width: 500,
                label: getMessage("paymentJournal.billReceiver"),
                dataKey: "billReceiver",
                cellRenderer: this.billReceiverCellRenderer
              },
              {
                width: 400,
                label: getMessage("patient"),
                dataKey: "patientId",
                cellRenderer: this.patientCellRenderer
              },
              {
                width: 200,
                label: getMessage("date"),
                dataKey: "date",
                cellRenderer: this.billDateCellRenderer
              },
              {
                width: 400,
                label: getMessage("paymentJournal.username"),
                dataKey: "treaterUsername",
                cellRenderer: this.treaterUsernameCellRenderer
              },
              {
                width: 150,
                label: getMessage("bill.amountHeader"),
                dataKey: "amount",
                cellRenderer: (data: any) => this.amountCellRenderer(data)
              },
              {
                width: 150,
                label: getMessage("paymentJournal.paid"),
                dataKey: "paidAmount",
                cellRenderer: (data: any) => this.paidAmountCellRenderer(data)
              }
            ]}
        />
    )
  };

  renderCashBox = (values: any): JSX.Element => {

    const {getMessage} = this.props;
    return (
        <CashBoxContainer>
          <Header>
            {getMessage("paymentJournal.cashBox")}: &nbsp;&nbsp; {numberFormatter.format(values.cashBox)}
          </Header>
        </CashBoxContainer>
    )
  }

  renderTablesLoader = (messageKey: string): JSX.Element => {

    const {getMessage} = this.props;
    return (
        <LoaderComponent
            message={`${getMessage("loading")} ${getMessage(messageKey).toLowerCase()}`}
        />
    )
  }

  headerRowRenderer = ({className, columns, style}: any) => {
    return (
        <StyledCell
            className={className}
            role="row"
            style={style}
        >
          {columns}
        </StyledCell>
    )
  };

  renderTotalsRowTable = (): React.ReactNode => {

    const {totalAmount, totalPaidAmount} = this.props;

    return (
        <StyledTotalsRowTable
            headerRowRenderer={this.headerRowRenderer}
            rowGetter={this.billsRowGetter([])}
            rowRenderer={this.billsRowRenderer}
            rowCount={0}
            columns={[
              {
                width: 100,
                label: "",
                dataKey: "id"
              },
              {
                width: 500,
                label: "",
                dataKey: "billReceiver"
              },
              {
                width: 400,
                label: "",
                dataKey: "patientId"
              },
              {
                width: 200,
                label: "",
                dataKey: "date"
              },
              {
                width: 420,
                label: "",
                dataKey: "treaterUsername"
              },
              {
                width: 150,
                label: numberFormatter.format(totalAmount),
                dataKey: "amount"
              },
              {
                width: 150,
                label: numberFormatter.format(totalPaidAmount),
                dataKey: "paidAmount"
              }
            ]}
        />
    )
  };

}

export default withAuthContext(withRouterWorkaround(withMessages(PaymentJournalTableSegment)));
